import { useNode } from '@craftjs/core';
import { Logo } from '@descope/page-editor-components';
import React, { useCallback } from 'react';
import { EditorBaseImageSettings } from '../../editorBase';

type Props = React.ComponentProps<typeof Logo>;

const EditorLogo = (props: Props) => {
	const {
		connectors: { connect, drag }
	} = useNode((state) => ({
		hasSelectedNode: state.events.selected,
		hasDraggedNode: state.events.dragged
	}));

	const refCb = useCallback(
		(ref: HTMLImageElement) => connect(drag(ref)),
		[connect, drag]
	);

	return (
		<div ref={refCb}>
			<Logo {...props} />
		</div>
	);
};

EditorLogo.craft = {
	name: 'Logo',
	props: {
		width: undefined,
		alt: 'Logo'
	},
	related: {
		settings: EditorBaseImageSettings
	}
};

export { EditorLogo };
